import React, { useContext} from 'react'

import {useAsync} from "react-use"


import errorNotification from "../firelib/error-notification"
import UserContext from "../firelib/user-context"

import Signout from "../firelib/signout"
import GoogleSignInButton from "../firelib/google-sign-in-button"
// import UserProvider from "../firelib/user-provider"
import PasswordProtected from "../firelib/password-protected"
import DeleteUser from "../firelib/delete-user"


import { List, Alert } from 'antd'


// function fullDriveUrl(url){
//     return "https://www.googleapis.com/drive/v3" + url   
// }

function listFiles({accessToken}){
    return fetch("https://www.googleapis.com/drive/v3/files?pageSize=10", {
        method: 'GET',
        headers: new Headers({ 'Authorization': 'Bearer ' + accessToken }),
    }).then((res) => {
        return res.json();
    });
}

function GoogleDriveFilesList(){
    const {accessToken} = useContext(UserContext)

    const files = useAsync(async ()=>{
        if (!accessToken){
            return null
        }

        return listFiles({accessToken})
    },[accessToken])

    if(files.error){
        errorNotification({operation:"when connecting to Google drive", error:files.error})        
    }

    if (files.value && files.value.error){
        const error = files.value.error
        const message = error.message
        return (
        <Alert 
            message="Google Drive files list error"
            description={message}
            type="warning"
            showIcon 
        />
        )
    }

    if (!accessToken){
        return (
            <Alert 
                message="Google Drive API is not available"
                description="Login, using Google Drive button!"
                type="warning"
                showIcon 
            />
        )        
    }

    return (<List
        style={{margin:10}}
        loading={files.loading}
        dataSource={(files.value && files.value.files) || []}
        renderItem={file=> <List.Item>{file.name}</List.Item>}
    />
    )
}

const LoginExample = () => {
    const googleLoginStyle = {maxWidth:200, marginLeft:20}
    return (
        <div style={{marginBottom: "1.5em"}}>
            <PasswordProtected
                buttons={[GoogleSignInButton]}
            >
                <Signout>Signout</Signout>
                <DeleteUser>Delete account</DeleteUser>
                <GoogleSignInButton style={googleLoginStyle}/>
                <GoogleSignInButton
                style = {googleLoginStyle}
                scopes = {["https://www.googleapis.com/auth/drive.readonly"]}
                >
                    Google Drive
                </GoogleSignInButton>
                <GoogleDriveFilesList/>
            </PasswordProtected>
        </div>       
    )
}

export default LoginExample